import { motion } from "framer-motion";
import React, { useRef } from "react";
import HTMLFlipBook from "react-pageflip";
import styled from "styled-components";
import { ApiImage } from "../models/api/image";
import { ImageConfig } from "../models/client";
import { fill } from "../styles/utils";
import { ImageFill } from "./ImageFill";

interface BookProps {
  pages: ImageConfig[];
  height: number;
  width: number;
  hasCover?: boolean;
}

const Boundary = styled.div`
  position: relative;
  max-width: 1400px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  height: 100%;
`;

const Container = styled(motion.div)`
  flex: 1;
  position: relative;
`;

const BookContainer = styled(motion.div)<{
  height: number;
  width: number;
  $minWidth: number;
}>`
  padding-top: ${({ height, width }) => (height / width) * 100}%;

  @media screen and (min-width: ${({ $minWidth }) =>
      2 * ($minWidth + 64) + 15}px) {
    padding-top: ${({ height, width }) => (height / (2 * width)) * 100}%;
  }

  & > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const PageTest = styled.div`
  background-color: white;
  /* border: 1px solid #efefef; */
`;

export const Book: React.FC<BookProps> = ({
  pages,
  width,
  height,
  hasCover = false,
}) => {
  return (
    <Boundary>
      <Container>
        <BookContainer height={height} width={width} $minWidth={300}>
          <div>
            {/* @ts-ignore */}
            <HTMLFlipBook
              size="stretch"
              width={width}
              height={height}
              minWidth={300}
              maxHeight={900}
              showCover={hasCover}
            >
              {pages.map((page) => (
                <PageTest key={page.title}>
                  <ImageFill src={page.src} />
                </PageTest>
              ))}
            </HTMLFlipBook>
          </div>
        </BookContainer>
      </Container>
    </Boundary>
  );
};
